module.exports = __webpack_public_path__ + "img/5.b6819c37.png";